import {DceComponent} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Dce from "dce-engine/lib/decorators/Dce";
import dragula from "dragula";
import {OpenDialog} from "dce-components";
import {DceAjax} from "dce-ajax";

interface InvoCategoryTreeProps {
    saveOrderUrl: string;
}

interface CategoryTreeIds {
    id:number,
    children: CategoryTreeIds[];
};


@Dce("InvoCategoryTree")
export default class InvoCategoryTree extends DceComponent<InvoCategoryTreeProps> {

    private jqElem: JQuery<HTMLElement>;
    private itemsDrops: dragula.Drake;

    constructor(elem: DceHTMLElement, props: InvoCategoryTreeProps) {
        super(elem, props);

        this.jqElem = $(elem);

        this.bindTogglesClick();

        this.initDragula();
    }

    private saveTreeOrder(){
        let roots = this.jqElem.find('.invo-ct__tree').children('.invo-ct__entry');

        let ser: CategoryTreeIds[] = roots.toArray().map((elem) => {
            return this.serializeEntryElement(elem);
        });

        let requestData = {
            tree: ser
        };

        console.log("SAVING DATA order", requestData);

        DceAjax.getInstance()
            .post(this.props.saveOrderUrl, requestData)

    }

    private serializeEntryElement(e: HTMLElement): CategoryTreeIds {

        let children = $(e).children('.invo-ct__entry-children').children('.invo-ct__entry')
            .toArray()
            .map((elem) => {
                return this.serializeEntryElement(elem);
            });

        return  {
            id: parseInt(e.dataset['id']),
            children: children
        };

    }


    onSubComponentInit(component: string, elem: DceHTMLElement) {

        let action = $(elem).data('action');

        if(component == 'OpenDialog' && action == 'edit'){

            let openDialog = elem.ext.getComponent('OpenDialog') as OpenDialog;

            let entryDiv = $(elem).closest('.invo-ct__entry');

            openDialog.addOnSavedClose((dialog, elem) => {

                let resp = dialog.getFormResponse();

                if(resp.hasData('tree_entry')){

                    let responseEntry = $(resp.getData('tree_entry'));

                    entryDiv.children('.invo-ct__entry-header').find('.invo-ct__entry-header-name').replaceWith(
                        responseEntry.find('.invo-ct__entry-header-name')
                    );
                }
            });

        }

        if(component == 'OpenDialog' && action == 'newroot'){

            let openDialog = elem.ext.getComponent('OpenDialog') as OpenDialog;

            let entryDiv = this.jqElem.find('.invo-ct__tree');

            openDialog.addOnSavedClose((dialog, elem) => {

                let resp = dialog.getFormResponse();

                if(resp.hasData('tree_entry')){
                    let responseEntry = $(resp.getData('tree_entry'));
                    entryDiv.append(responseEntry);
                    this.refreshToggles();
                    this.saveTreeOrder();
                }
            });

        }

        if(component == 'OpenDialog' && action == 'create'){

            let openDialog = elem.ext.getComponent('OpenDialog') as OpenDialog;

            let entryDiv = $(elem).closest('.invo-ct__entry');

            openDialog.addOnSavedClose((dialog, elem) => {

                let resp = dialog.getFormResponse();

                if(resp.hasData('tree_entry')){
                    let responseEntry = $(resp.getData('tree_entry'));
                    entryDiv.children('.invo-ct__entry-children').append(responseEntry);
                    this.refreshToggles();
                    this.saveTreeOrder();
                }
            });

        }

        super.onSubComponentInit(component, elem);
    }

    private bindTogglesClick(){
        this.jqElem.on('click', '.invo-ct__entry-header-toggle', e => {
            $(e.target).closest('.invo-ct__entry').toggleClass('invo-ct__entry--opened');
        });

        this.jqElem.find('*[ref="collapse-all"]').on('click', e => {
            console.log('expand all');

            this.jqElem.find('.invo-ct__entry').removeClass('invo-ct__entry--opened');
        });

        this.jqElem.find('*[ref="expand-all"]').on('click', e => {
            console.log('collapse all');
            this.jqElem.find('.invo-ct__entry').addClass('invo-ct__entry--opened');
        });

    }

    private refreshToggles(){
        this.jqElem.find('.invo-ct__entry').each((i, elem) => {
            if( $(elem).find('.invo-ct__entry-children > div').length == 0 ){
                $(elem).addClass('invo-ct__entry--empty')
            }else{
                $(elem).removeClass('invo-ct__entry--empty')
            }
        });
    }

    private initDragula() {

        let containers: HTMLElement[] = [];

        this.jqElem.find('.invo-ct__tree').each((e, elem) => {
            containers.push(elem);
        });

        this.jqElem.find('.invo-ct__entry-children').each((i, elem) => {
            containers.push(elem);
        });

        this.itemsDrops = dragula(
            containers,
            {
                removeOnSpill: false,
                revertOnSpill: true,
                moves: function (el, container, handle) {
                    return handle.classList.contains('invo-ct__entry-header-name')
                        || handle.parentElement.classList.contains('invo-ct__entry-header-name');
                }
            }
        )
        .on("drag", (el, source) => {
            setTimeout(() => {
                this.jqElem.addClass('invo-ct--dragging');
            }, 20);
        })
        .on("dragend", (el) => {
            this.jqElem.removeClass('invo-ct--dragging');
            this.refreshToggles();
            this.saveTreeOrder();
        })
        .on('drop', (el, target, source, sibling) => {
            $(el).find('.invo-ct__entry-children').css('display', '');

            let catId = $(el).data('id');
            let parentId = $(target).data('id');

            console.log('Category ID: ', catId);
            console.log('New parent ID', parentId);

        })
        .on('shadow', (el, container, source) => {
            this.jqElem.find('.invo-ct__entry-children').removeClass('invo-ct__entry-children--hover');
            $(container).addClass('invo-ct__entry-children--hover');
        });

    }

}